import React from "react";
import "./App.css";

const App = () => {
  const location = new URLSearchParams(window.location.search);
  const app = location.get("App");

  return (
    <div className="App">
      <h2 className="first">Pol&iacute;tica Privacidade</h2>
      <p className="second">
        A sua privacidade &eacute; importante para n&oacute;s. &Eacute; pol&iacute;tica do {app} respeitar a sua privacidade em rela&ccedil;&atilde;o a qualquer
        informa&ccedil;&atilde;o sua que possamos coletar no site/app {app}, e outros site/apps que possu&iacute;mos e operamos.
      </p>
      <p className="second">
        Solicitamos informa&ccedil;&otilde;es pessoais apenas quando realmente precisamos delas para lhe fornecer um servi&ccedil;o. Fazemo-lo por meios justos
        e legais, com o seu conhecimento e consentimento. Tamb&eacute;m informamos por que estamos coletando e como ser&aacute; usado.
      </p>
      <p className="second">
        Apenas retemos as informa&ccedil;&otilde;es coletadas pelo tempo necess&aacute;rio para fornecer o servi&ccedil;o solicitado. Quando armazenamos dados,
        protegemos dentro de meios comercialmente aceit&aacute;veis ​​para evitar perdas e roubos, bem como acesso, divulga&ccedil;&atilde;o, c&oacute;pia, uso
        ou modifica&ccedil;&atilde;o n&atilde;o autorizados.
      </p>
      <p className="second">
        N&atilde;o compartilhamos informa&ccedil;&otilde;es de identifica&ccedil;&atilde;o pessoal publicamente ou com terceiros, exceto quando exigido por lei.
      </p>
      <p className="second">
        O nosso site/app pode ter links para site/apps externos que n&atilde;o s&atilde;o operados por n&oacute;s. Esteja ciente de que n&atilde;o temos
        controle sobre o conte&uacute;do e pr&aacute;ticas desses site/apps e n&atilde;o podemos aceitar responsabilidade por suas respectivas pol&iacute;ticas
        de privacidade.
      </p>
      <p className="second">
        Voc&ecirc; &eacute; livre para recusar a nossa solicita&ccedil;&atilde;o de informa&ccedil;&otilde;es pessoais, entendendo que talvez n&atilde;o
        possamos fornecer alguns dos servi&ccedil;os desejados.
      </p>
      <p className="second">
        O uso continuado de nosso site/app ser&aacute; considerado como aceita&ccedil;&atilde;o de nossas pr&aacute;ticas em torno de{" "}
        <a href="https://avisodeprivacidad.info/" rel="nofollow noreferrer" target="_BLANK" className="fourth">
          generador de avisos de privacidad
        </a>{" "}
        e informa&ccedil;&otilde;es pessoais. Se voc&ecirc; tiver alguma d&uacute;vida sobre como lidamos com dados do usu&aacute;rio e
        informa&ccedil;&otilde;es pessoais, entre em contacto connosco.
      </p>
      <p className="second"></p>
      <h3 className="fifth">Compromisso do Usu&aacute;rio</h3>
      <p className="second">
        O usu&aacute;rio se compromete a fazer uso adequado dos conte&uacute;dos e da informa&ccedil;&atilde;o que o {app} oferece no site/app e com
        car&aacute;ter enunciativo, mas n&atilde;o limitativo:
      </p>
      <ul className="sixth">
        <li className="seventh">
          A) N&atilde;o se envolver em atividades que sejam ilegais ou contr&aacute;rias &agrave; boa f&eacute; a &agrave; ordem p&uacute;blica;
        </li>
        <li className="seventh">
          B) N&atilde;o difundir propaganda ou conte&uacute;do de natureza racista, xenof&oacute;bica,{" "}
          <a href="https://apostasonline.guru/" rel="nofollow noreferrer" target="_BLANK" className="fourth">
            casas de apostas
          </a>{" "}
          ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os direitos humanos;
        </li>
        <li className="seventh">
          C) N&atilde;o causar danos aos sistemas f&iacute;sicos (hardwares) e l&oacute;gicos (softwares) do {app}, de seus fornecedores ou terceiros, para
          introduzir ou disseminar v&iacute;rus inform&aacute;ticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de causar danos
          anteriormente mencionados.
        </li>
      </ul>
      <h3 className="fifth">Mais informa&ccedil;&otilde;es</h3>
      <p className="second">
        Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que voc&ecirc; n&atilde;o tem certeza se precisa ou n&atilde;o,
        geralmente &eacute; mais seguro deixar os cookies ativados, caso interaja com um dos recursos que voc&ecirc; usa em nosso site/app.
      </p>
      <p className="second">
        Esta pol&iacute;tica &eacute; efetiva a partir de <strong>24 setembro 2022 18:44</strong>
      </p>
    </div>
  );
};

export default App;
